import React from 'react';
import { Container, Row, Col, Card } from 'react-bootstrap';
import img1 from '../../assets/growth_strategy1.jpg';
import img2 from '../../assets/powerfull_tools.jpg';
import img3 from '../../assets/marketing_managment.jpg';

const Blog = () => {
  const latestPosts = [
    {
      image: img1,
      title: 'How to Build a Growth Strategy That Works',
      description: 'Practical steps to align goals, channels and execution for predictable growth.',
      link: '#'
    },
    {
      image: img2,
      title: 'Market Research: Start With Customer Problems',
      description: 'A simple framework to validate ideas with low-cost research.',
      link: '#'
    },
    {
      image: img3,
      title: 'Brand Positioning: Say Less, Mean More',
      description: 'Craft a clear message that differentiates and converts.',
      link: '#'
    }
  ];

  const tutorials = [
    {
      title: 'Set Up Your First Campaign',
      description: 'Step-by-step guide to launching a high-ROI campaign.'
    },
    {
      title: 'Create a Simple Customer Persona',
      description: 'Use real data to define who you\'re building for.'
    }
  ];

  const news = [
    {
      type: 'Announcement',
      description: 'We\'re launching new analytics features to track cohort retention.'
    },
    {
      type: 'Release Note',
      description: 'Performance improvements and UI refinements in the dashboard.'
    }
  ];

  return (
    <section className="section-lg overflow-hidden" id="blog">
      <Container>
        <Row>
          <Col xs={12} className="mb-5">
            <div className="text-center">
              <h6 className="underline-after position-relative z-0">
                <span className="position-relative z-1 bg-white text-primary px-3">From Our Blog</span>
              </h6>
              <h2 className="text-gradiant fw-semibold display-6">Insights, Tips &amp; Stories</h2>
            </div>
          </Col>
        </Row>

        {/* Latest Posts */}
        <Row className="mb-4" id="blog-latest">
          <Col xs={12} className="mb-3">
            <h4 className="text-primary mb-0">Latest Posts</h4>
          </Col>
          {latestPosts.map((post, idx) => (
            <Col key={idx} lg={4} md={6} xs={12} className="mb-4">
              <Card className="h-100 shadow-sm">
                <Card.Img variant="top" src={post.image} alt="Post" />
                <Card.Body>
                  <Card.Title>{post.title}</Card.Title>
                  <Card.Text className="text-secondary">{post.description}</Card.Text>
                  <a href={post.link} className="text-primary text-decoration-none">Read More <i className="ri-arrow-right-line"></i></a>
                </Card.Body>
              </Card>
            </Col>
          ))}
        </Row>

        {/* Tutorials */}
        <Row className="mb-4" id="blog-tutorials">
          <Col xs={12} className="mb-3">
            <h4 className="text-primary mb-0">Tutorials</h4>
          </Col>
          {tutorials.map((tutorial, idx) => (
            <Col key={idx} md={6} xs={12} className="mb-3">
              <div className="p-4 border rounded-3 h-100">
                <h5 className="mb-2">{tutorial.title}</h5>
                <p className="mb-0 text-secondary">{tutorial.description}</p>
              </div>
            </Col>
          ))}
        </Row>

        {/* Case Studies */}
        <Row className="mb-4" id="blog-case-studies">
          <Col xs={12} className="mb-3">
            <h4 className="text-primary mb-0">Case Studies</h4>
          </Col>
          <Col xs={12}>
            <div className="p-4 bg-light rounded-3 border">
              <h5 className="mb-2">How We Increased Qualified Leads by 3x in 60 Days</h5>
              <p className="mb-0 text-secondary">Tactics, experiments and lessons learned.</p>
            </div>
          </Col>
        </Row>

        {/* News & Updates */}
        <Row id="blog-news">
          <Col xs={12} className="mb-3">
            <h4 className="text-primary mb-0">News &amp; Updates</h4>
          </Col>
          {news.map((item, idx) => (
            <Col key={idx} md={6} xs={12} className="mb-3">
              <div className="p-4 border rounded-3 h-100">
                <h6 className="text-success mb-1">{item.type}</h6>
                <p className="mb-0">{item.description}</p>
              </div>
            </Col>
          ))}
        </Row>
      </Container>
    </section>
  );
};

export default Blog;
